(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    function initSizeGuide(root) {
      if (!root || root.getAttribute('data-gl-size-guide-ready') === 'true') return;
      root.setAttribute('data-gl-size-guide-ready', 'true');

      var trigger = root.querySelector('[data-gl-size-guide-open]');
      var overlay = root.querySelector('[data-gl-size-guide-overlay]');
      var drawer = root.querySelector('[data-gl-size-guide-drawer]');
      var closeControls = root.querySelectorAll('[data-gl-size-guide-close]');
      var fitButtons = root.querySelectorAll('[data-gl-size-guide-fit]');
      var chartPanels = root.querySelectorAll('[data-gl-size-guide-chart]');
      if (!trigger || !overlay || !drawer) return;

      function getFocusableElements() {
        var selector = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
        return Array.prototype.filter.call(drawer.querySelectorAll(selector), function (element) {
          return !element.hidden && element.offsetParent !== null;
        });
      }

      function openDrawer() {
        overlay.classList.add('is-open');
        overlay.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        window.requestAnimationFrame(function () {
          drawer.focus();
        });
      }

      function closeDrawer() {
        if (!overlay.classList.contains('is-open')) return;
        overlay.classList.remove('is-open');
        overlay.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }

      function selectFit(index) {
        Array.prototype.forEach.call(fitButtons, function (button) {
          var isSelected = button.getAttribute('data-gl-size-guide-fit') === index;
          button.classList.toggle('is-active', isSelected);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
        Array.prototype.forEach.call(chartPanels, function (panel) {
          panel.hidden = panel.getAttribute('data-gl-size-guide-chart') !== index;
        });
      }

      trigger.addEventListener('click', openDrawer);
      Array.prototype.forEach.call(closeControls, function (control) {
        control.addEventListener('click', closeDrawer);
      });
      Array.prototype.forEach.call(fitButtons, function (button) {
        button.addEventListener('click', function () {
          selectFit(button.getAttribute('data-gl-size-guide-fit'));
        });
      });

      overlay.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDrawer();
          return;
        }
        if (event.key !== 'Tab') return;

        var focusableElements = getFocusableElements();
        if (!focusableElements.length) {
          event.preventDefault();
          drawer.focus();
          return;
        }

        var firstElement = focusableElements[0];
        var lastElement = focusableElements[focusableElements.length - 1];
        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      });
    }

    function initAllSizeGuides() {
      var sizeGuides = document.querySelectorAll('[data-gl-size-guide]');
      Array.prototype.forEach.call(sizeGuides, initSizeGuide);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllSizeGuides);
    } else {
      initAllSizeGuides();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
